import { Flex, FormControl, FormErrorMessage, FormHelperText, FormLabel, Spinner } from "@chakra-ui/react";
import { type ReactNode, useState } from "react";
import { useTranslation } from "react-i18next";
import { RemoveDataFieldButton } from "../RemoveDataFieldButton";
import { ISODateSelector } from "./ISODateSelector";

interface Props {
  id: string;
  title: string;
  helperText: string;
  defaultDate?: string;
  date?: string | null;
  errorMessage: ReactNode;
  onChange: (date?: string) => Promise<void> | void;
  removeDataField?: () => Promise<void> | void;
  isRequiredButNotProvided: boolean;
  isDisabled?: boolean;
  savesTypingOnLeave?: boolean;
}

export const ISODateFormControl = ({
  id,
  title,
  helperText,
  defaultDate,
  date,
  errorMessage,
  onChange,
  removeDataField,
  isRequiredButNotProvided,
  isDisabled,
  savesTypingOnLeave,
}: Props) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [isIncomplete, setIsIncomplete] = useState(false);
  return (
    <FormControl id={id} isInvalid={isIncomplete || errorMessage !== null} isRequired={isRequiredButNotProvided}>
      <FormLabel fontSize="sm">
        {title}
        {isLoading && <Spinner ml="5px" size="xs" />}
      </FormLabel>
      <Flex justify="space-between" align="center">
        <ISODateSelector
          defaultDate={defaultDate}
          date={date}
          isDisabled={isDisabled}
          savesTypingOnLeave={savesTypingOnLeave}
          onIncompleteChange={setIsIncomplete}
          onChange={async (date) => {
            setIsLoading(true);
            await onChange(date);
            setIsLoading(false);
          }}
        />
        {removeDataField && <RemoveDataFieldButton removeDataField={removeDataField} />}
      </Flex>
      <FormHelperText>{helperText}</FormHelperText>
      <FormErrorMessage>{isIncomplete ? t("The date is not complete") : errorMessage}</FormErrorMessage>
    </FormControl>
  );
};
